import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import * as $ from 'jquery';
declare var $: any; 

@Component({
  selector: 'app-cosmetic-surgery',
  templateUrl: './cosmetic-surgery.component.html',
  styleUrls: ['./cosmetic-surgery.component.css']
})
export class CosmeticSurgeryComponent implements OnInit {

  thankyou: boolean = false;
  loading: boolean = false;
  error: any;
  data: any = {};
  url:string;
  specializationType: string;
  userData: any;
  disable: boolean = true;
  hasEcard:boolean;
  MongoDataToSaved:any={};
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private serviceURLService: serviceURLService,private router: Router) { }

  ngOnInit() {
    //this.getUserData();
    // this.CheckIfEcardUser();
  }

  bookAppointment(specialization) {
    const obj={
      specialization:specialization,
      userId: localStorage.getItem('userID')
    }
    this.serviceURLService.getCosmeticStatus(obj).subscribe((success: any) => {
   
     console.log(success.response)
    
      this.disable=!success.response

      console.log(success.response,this.disable)
     
    this.specializationType = specialization;
    })
  }

  getUserData() {
    this.loading = true;
    this.serviceURLService.getUserData().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.userData = successData.response.completeUserData;
      this.loading = false;
    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

    confirmAppointment(specialization) {
    $("#thankyou").modal("show");
    //this.savePolyclinicInMongo(specialization);
    this.data = {
      // name: this.userData.name ? this.userData.name : localStorage.getItem("name"),
      // email: this.userData.email ? this.userData.email : localStorage.getItem("email"),
      // mobile: this.userData.mobile ? this.userData.mobile : localStorage.getItem("mobileNumber"),
      // company: this.userData.company ? this.userData.company : localStorage.getItem("companyName"),
      name:localStorage.getItem("name"),
      email:localStorage.getItem("email"),
      mobile:localStorage.getItem("mobileNumber"),
      company:localStorage.getItem("companyName")?localStorage.getItem("companyName"):"",
      specialization: specialization,
      userId: localStorage.getItem('userID')
    }
    this.serviceURLService.saveCosmeticCare(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
    }, errorData => {
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })

  }

  // CheckIfEcardUser(){
  //   this.loading=true
  //   var userId = localStorage.getItem("userID")
  //   this.serviceURLService.getPoliciesEcards(userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
  //     const insuranceDetails = successData.response.notifyPolicy;
  //     console.log(insuranceDetails)
  //     if(insuranceDetails.length>0){
  //       this.hasEcard=false
  //        this.loading=false
  //     }
  //     else{
  //       this.hasEcard=true
  //       this.loading=false
  //     }
  //   }, errorData => {
  //      this.loading = false;
  //       this.router.navigate(['login']);
  //   })
  // }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
